import { ConsumptionFilter } from '@/types/filters/filters.types';
import { atom, DefaultValue, selector } from 'recoil';

const defaultConsumption: ConsumptionFilter = {
  min: 0,
  max: 0,
};

export const consumptionDefaultState = atom<ConsumptionFilter>({
  key: 'consumptionDefaultState',
  default: {
    min: defaultConsumption.min,
    max: defaultConsumption.max,
  },
});

export const consumptionFilterState = atom<ConsumptionFilter>({
  key: 'consumptionFilterState',
  default: defaultConsumption,
});

const selectedConsumptionFilterState = atom<ConsumptionFilter>({
  key: 'selectedConsumptionFilterState',
  default: defaultConsumption,
});

export const selectedConsumptionFilterSelector = selector<ConsumptionFilter>({
  key: 'selectedConsumptionFilterSelector',
  get({ get }) {
    return get(selectedConsumptionFilterState);
  },
  set({ get, set }, consumption) {
    if (consumption instanceof DefaultValue) {
      return;
    }

    const consumptionFilterDefault = get(consumptionDefaultState);

    if (
      consumptionFilterDefault.min === consumption.min &&
      consumptionFilterDefault.max === consumption.max
    ) {
      return set(selectedConsumptionFilterState, { min: 0, max: 0 });
    }

    return set(selectedConsumptionFilterState, consumption);
  },
});

export const hasSelectedConsumptionFilterSelector = selector<boolean>({
  key: 'hasSelectedConsumptionFilter',
  get({ get }) {
    const { min, max } = get(selectedConsumptionFilterState);

    return Boolean(min) && Boolean(max);
  },
});

export const selectedConsumptionFilterLabelSelector = selector({
  key: 'selectedConsumptionFilterLabel',
  get({ get }) {
    const hasSelectedConsumptionFilter = get(
      hasSelectedConsumptionFilterSelector
    );
    const { min, max } = get(selectedConsumptionFilterState);

    if (hasSelectedConsumptionFilter) {
      return `${min} - ${max}`;
    }

    return '';
  },
});
